import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

import { SharedLinkAddPaymentMethodPage } from 'src/pages/shared-link/add-payment-method/add-payment-method';

import { SharedLinkService } from 'src/shared/services/shared-link.service';

import { SharedLinkResponse } from 'src/models/shared-link.model';

import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Auth } from 'src/providers/auth/auth';

@Component({
  templateUrl: 'shared-link.page.html',
  standalone: false
})
export class SharedLinkPage implements OnInit {
  loaded = false;
  expired = false;
  errorMessage = '';
  sharedLink: SharedLinkResponse;

  constructor(
    private route: ActivatedRoute,
    private rightSidePanelService: RightSidePanelService,
    private navCtrl: CustomNavController,
    private sharedLinkService: SharedLinkService,
    private storage: TidyStorage,
    private auth: Auth
  ) {}

  async ngOnInit(): Promise<void> {
    const dialogParams = await this.storage.retrieve('dialog-params');
    const uuid = this.route.snapshot.paramMap.get('uuid') || dialogParams?.uuid;
    if (!uuid) {
      this.errorMessage = 'Invalid link.';
      return;
    }

    try {
      this.sharedLink = await this.sharedLinkService.getSharedLink(uuid);

      if (this.sharedLink.shared_link_data.expired) {
        this.expired = true;
        this.loaded = true;
        return;
      }

      this.loaded = true;

      if (this.auth.isAuthenticated()) {
        this.redirectAuthenticatedUser(uuid);
      } else {
        this.navigateToAction(uuid);
      }
    } catch (err) {
      if (err?.status === 404) {
        this.expired = true;
      } else {
        this.errorMessage = err?.message || err?.error?.message || 'Something went wrong. Please try again.';
      }
      this.loaded = true;
    }
  }

  private async redirectAuthenticatedUser(uuid: string): Promise<void> {
    const actionType = this.sharedLink.shared_link_data.action_type;
    const params: Record<string, any> = { uuid, sharedLink: this.sharedLink };
    let component: any;

    switch (actionType) {
      case 'ai_task_add_payment_method':
        component = SharedLinkAddPaymentMethodPage;
        break;
      default:
        this.errorMessage = `Unsupported action: ${actionType}`;
        return;
    }

    await this.storage.save('dialog-params', params);
    await this.storage.save('dialog-right-side-open', true);
    this.navCtrl.navigateForward('properties');
    setTimeout(() => {
      this.rightSidePanelService.openRightSidePanel(component);
    }, 500);
  }

  private navigateToAction(uuid: string): void {
    const actionType = this.sharedLink.shared_link_data.action_type;

    switch (actionType) {
      case 'ai_task_add_payment_method':
        this.rightSidePanelService.navigateTo(
          'shared-link/add-payment-method',
          { uuid, sharedLink: this.sharedLink },
          SharedLinkAddPaymentMethodPage
        );
        break;
      default:
        this.errorMessage = `Unsupported action: ${actionType}`;
    }
  }
}
